(ns practitest.frontend.kanban.board
  (:require
    [practitest.frontend.common-old-fe.rbdnd :as rbdnd]
    [practitest.frontend.components2.run-status :as run-status]
    [re-frame.core :as re-frame]))

(defn run-status-bar-ui [entity]
  (let [values (:run_status_bar entity)
        total (transduce (map second) + values)
        exploratory? (= (:test/test_type entity) "ExploratoryTest")]
    (when (pos? total)
      [:div.progress
       (keep-indexed
         (fn [index [status count]]
           (when status
             ^{:key index}
             [:div.progress-bar
              {:style {:width (str (js/Math.floor (* 100 (/ count total))) "%")
                       :background-color (run-status/get-status-color (name status) exploratory?)}}]))
         values)])))

(defn assigned-to-ui [entity]
  [:div
   [:span.badge.badge-assigned-to]
   (get-in entity [:assigned_to :value])])



(defn run-testset-ui [entity]
  [:button.btn.btn-default.btn-outline-secondary
   {:on-click #(re-frame/dispatch [:kanban/run-testset entity])}
   [:i.fa.fa-play.fa-fw] "Run"])

(defn remove-card-ui [entity]
  [:a {:href     "#"
       :title    "Remove from Task Board"
       :on-click (fn [e]
                   (.preventDefault e)
                   (re-frame/dispatch [:kanban/remove-card
                                       (:lane entity)
                                       (str (:entity entity) ":" (:system_id entity))]))}
   [:i.fa.fa-archive.fa-fw]])

(defn title [prefix text uri]
  [:div.title-box
   [:b.prefix prefix]
   [:a.title {:href   uri
              :target "_BLANK"}
    " " text]])

(defmulti entity-action-row-ui :entity)

(defmethod entity-action-row-ui "Suite" [entity]
  [:div.row
   [:div.col-xs-12
    [:div.actions-bar
     [:div.status
      [run-status-bar-ui entity]]
     [:div.assigned-to
      [assigned-to-ui entity]]
     [:div.run]
     (when-not (:read-only? entity)
       [:div.actions
        [remove-card-ui entity]])]]])

(defmethod entity-action-row-ui "Requirement" [entity]
  [:div.row
   [:div.col-xs-12
    [:div.actions-bar
     [:div.status
      (when-let [[label icon] (:status entity)]
        [:span [:img {:src icon :alt ""}] " " label])]
     [:div.assigned-to
      [assigned-to-ui entity]]
     [:div.run]
     (when-not (:read-only? entity)
       [:div.actions
        [remove-card-ui entity]])]]])

(defn add-vertical-bar [entity path]
  (when (not-empty (get-in entity path))
    " | "))

(defmethod entity-action-row-ui "Issue" [entity]
  [:div.row
   [:div.col-xs-12
    [:div.actions-bar.issue-actions-bar
     [:div (concat (get-in entity [:issue_type :value])
                   (add-vertical-bar entity [:issue_type :value])
                   (get-in entity [:issue_status :value])
                   (add-vertical-bar entity [:assigned_to :value])
                   (get-in entity [:assigned_to :value]))]
     [:div.run]
     (when-not (:read-only? entity)
       [:div.actions
        [remove-card-ui entity]])]]])

(defmethod entity-action-row-ui "QtestDesign" [entity]
  [:div.row
   [:div.col-xs-12
    [:div.actions-bar
     [:div.status
      (when-let [[label icon] (:status entity)]
        [:span [:img {:src icon :alt ""}] " " label])]
     [:div.assigned-to
      [assigned-to-ui entity]]
     [:div.run]
     (when-not (:read-only? entity)
       [:div.actions
        [remove-card-ui entity]])]]])

(defmulti entity-ui :entity)

(defmethod entity-ui "Requirement" [entity]
  [:div
   [:div.row
    [:div.col-md-12.entity-ui-req
     [title (str "Req #" (:id entity)) (:name entity) (:uri entity)]]]
   [entity-action-row-ui entity]])

(defmethod entity-ui "Issue" [entity]
  [:div
   [:div.row
    [:div.col-md-12.entity-ui-issue
     [title (str "Issue #" (:id entity)) (:title entity) (:uri entity)]]]
   [entity-action-row-ui entity]])

(defmethod entity-ui "QtestDesign" [entity]
  [:div
   [:div.row
    [:div.col-md-12.entity-ui-test
     [title (str "Test #" (:id entity)) (:name entity) (:uri entity)]]]
   [entity-action-row-ui entity]])

(defmethod entity-ui "Suite" [entity]
  [:div
   [:div.row
    [:div.col-md-12.entity-ui-suite
     (when @(re-frame/subscribe [:kanban/can-run-testset?])
       [:div.run
        [run-testset-ui entity]])
     [title (str "Set #" (:id entity)) (:name entity) (:uri entity)]]]
   [entity-action-row-ui entity]])

(defmethod entity-ui "HIDDEN" [entity]
  [:div
   [:div.row
    [:div.col-md-12
     [:div.title-box
      {:style {:padding-top 30}}
      [:p.title.text-center.text-muted
       [:i.fa.fa-3x.fa-eye-slash
        {:title "You don't have permissions to view this entity"}]]]]]])

(defmethod entity-ui :default [entity]
  [:p "placeholder"])

(defn list-style [dragging-over]
  {:background    (when dragging-over "silver")
   :padding-left  "0"
   :padding-right "8px"
   :margin-right  0
   :margin-left   0
   :min-height    400
   :transition    "background-color 0.1s ease"})

(defn item-style [dragging]
  {:user-select "none"
   :margin      "0 0 0 8px"
   :opacity     (if dragging 0.8 1.0)
   :transition  "opacity 0.1s ease"})

(defn lane-ui [lane]
  (let [cards (re-frame/subscribe [:kanban/cards (:id lane)])]
    (fn [lane]
      [:div.kanban-lane.col-md-3
       [rbdnd/droppable
        {:id        (str (:id lane))
         :direction "vertical"
         :style-f   list-style
         :title     [:h5 (str (:name lane) " (" (count @cards) ")")]}
        (for [card @cards]
          [rbdnd/draggable
           {:id        (str (:entity card) ":" (:system_id card))
            :ix        (:position card)
            :style-f   item-style
            :disabled? (:read-only? card)}
           [:div.card [entity-ui (assoc card :lane (:id lane))]]])]])))

(defn board-ui []
  (let [lanes (re-frame/subscribe [:kanban/lanes])
        can-edit-lanes? (re-frame/subscribe [:kanban/can-edit-lanes?])]

    (fn []
      [:div.kanban-board
       (if (empty? @lanes)
         [:div.row-fluid
          [:div.col-md-12
           [:p.lead.text-center.text-muted
            [:i.fa.fa-lg.fa-exclamation-triangle.text-warning] " This project doesn't have any lanes configured yet."
            [:br]
            (if @can-edit-lanes?
              "Please use 'Customize lanes' button above to configure lanes."
              "Please ask your account admin to configure lanes.")]]]
         [:<>
          [:div.row-fluid
           [rbdnd/drag-drop-context
            {:on-drag-end (fn [source destination draggable-id]
                            (when destination
                              (re-frame/dispatch [:kanban/drop
                                                  (:droppableId source)
                                                  draggable-id
                                                  (:droppableId destination)
                                                  (:index destination)])))}
            (for [lane @lanes]
              ^{:key (:id lane)} [lane-ui lane])]]])])))
